module.exports = __webpack_public_path__ + "img/9.a57f93f1.jpg";